import React from 'react';
import { Skill } from '../../../../types/resume';

interface SkillsListProps {
  skills: Skill[];
  className?: string;
  layout?: 'list' | 'cloud';
  groupByCategory?: boolean;
  categoryClassName?: string;
  skillClassName?: string;
  showLevel?: boolean;
}

export function SkillsList({ 
  skills, 
  className = '', 
  layout = 'list',
  showLevel = true,
  groupByCategory = false,
  categoryClassName = '',
  skillClassName = ''
}: SkillsListProps) {
  const groupedSkills = skills.reduce((acc, skill) => {
    if (!acc[skill.category]) acc[skill.category] = [];
    acc[skill.category].push(skill);
    return acc;
  }, {} as Record<string, Skill[]>);

  if (layout === 'cloud') {
    return (
      <div className={className}>
        <div className="flex flex-wrap gap-2">
          {skills.map((skill) => (
            <span
              key={skill.id}
              className={`text-gray-700 text-xs ${skillClassName}`}
            >
              {skill.name}
            </span>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div className={className}>
      {Object.entries(groupedSkills).map(([category, categorySkills]) => (
        <div key={category} className="mb-2">
          {groupByCategory && (
            <h3 className={categoryClassName}>{category}</h3>
          )}
          <div className={groupByCategory ? '' : 'inline'}>
            {categorySkills.map((skill) => (
              <div key={skill.id} className={`${groupByCategory ? '' : 'inline'}`}>
                <span className={skillClassName}>
                  {skill.name}
                </span>
                {!groupByCategory && categorySkills.indexOf(skill) !== categorySkills.length - 1 && (
                  <span className="mx-1 text-gray-400">•</span>
                )}
                {showLevel && (
                  <div className="w-16 h-1 bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-current"
                      style={{
                        width: `${
                          skill.level === 'beginner' ? '25%' :
                          skill.level === 'intermediate' ? '50%' :
                          skill.level === 'advanced' ? '75%' : '100%'
                        }`
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}